import { render, staticRenderFns } from "./OrderableCartItemSections.vue?vue&type=template&id=2c1f59c4&"
import script from "./OrderableCartItemSections.vue?vue&type=script&lang=ts&"
export * from "./OrderableCartItemSections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports